import React from "react";
import {
  Workspaces,
  Timer,
  AccessTime,
  Schedule,
  AutoAwesome,
  Assignment,
  FilterTiltShift,
  Payments,
  MoreTime,
  AccessibilityNew,
  HolidayVillage,
  PersonOff,
  AttachMoney,
  TransferWithinAStation,
  FreeBreakfast,
  PersonAddAlt,
  Badge,
  Groups,
  ModeStandby,
  DateRange,
  Category,
  Group,
  Autorenew,
} from "@mui/icons-material";
import moment from "moment";

export const userHeader = [
  { name: "Name", key: "user_name" },
  { name: "User Code", key: "user_code" },
  { name: "User Type", key: "type" },
  { name: "Designation", key: "designation" },
  { name: "Employment Type", key: "employment_type" },
  { name: "Department", key: "department" },
  { name: "Department Lead", key: "department_lead_name" },
  { name: "Company Name", key: "company_name" },
  { name: "System Access", key: "system_access" },
  { name: "Status", key: "status" },
  { name: "Action", key: "" },
];

export const employmentTypeHeader = [
  { name: "" },
  { name: "Employment Type" },
  { name: "Description" },
  { name: "Actions" },
];

export const departmentMembersHeader = [
  { name: "" },
  { name: "Name" },
  { name: "User code" },
  { name: "Designation" },
  { name: "Employment Type" },
  { name: "Phone Number" },
  { name: "System Access" },
  { name: "Status" },
];
export const departmentMembersHeaderAction = [
  { name: "" },
  { name: "Name" },
  { name: "User code" },
  { name: "Designation" },
  { name: "Employment Type" },
  { name: "Phone Number" },
  { name: "System Access" },
  { name: "Status" },
  { name: "Action" },
];

export const companyHeader = [
  { name: "" },
  { name: "Company Name" },
  { name: "Company Code" },
  { name: "Address" },
  { name: "Gst No" },
  { name: "Email" },
  { name: "Phone Number" },
  { name: "Status" },
  { name: "Type" },
  { name: "Action" },
];

export const groupProductHeader = [
  { name: "" },
  { name: "Products" },
  { name: "Role" },
  { name: "Action" },
];

export const groupUserHeader = [
  { name: "" },
  { name: "Name" },
  { name: "User Code" },
  { name: "Email" },
  { name: "Action" },
];

export const PayingUnitHeader = [
  { name: "Department", key: "department_name" },
  { name: "WorkUnit Name", key: "work_unit_name" },
  { name: "Total Number of WorkUnits", key: "total_number_of_work_unit" },
  { name: "Type of WorkUnit Payment", key: "unit_type" },
  { name: "Amount Per WorkUnit", key: "amount" },
  { name: "Effective From", key: "effective_from" },
  { name: "Actions" },
];

export const GroupUnitHeader = [
  { name: "Department", key: "department_name" },
  { name: "WorkUnit Name", key: "name" },
  { name: "Effective From", key: "effective_from" },
  { name: "Actions" },
];

export const AssignGroupUnitHeader = [
  { name: "WorkUnit Group Name", key: "name" },
  { name: "Employee Count", key: "employee_count" },
  { name: "Effective From", key: "start_date" },
  { name: "Effective To", key: "end_date" },
  { name: "Actions" },
];

export const IndividualMemberHeader = [
  { name: "Employee ID", key: "employee_id" },
  // { name: "Department", key: "department" },
  { name: "Employee Name", key: "user_name" },
];

export const IndividualSftGrpMemberHeader = [
  { name: "Employee Name", key: "username" },
  { name: "Department", key: "department_name" },
  { name: "Shift Category", key: "shift_category_name" },
  { name: "Manager", key: "manager_name" },
  { name: "Phone Number", key: "phone_number" },
  { name: "Action", key: "action" },
];

export const shiftTypes = [
  { id: 1, label: "Rotational" },
  { id: 2, label: "Non Rotational" },
  { id: 3, label: "Random" },
];

export const ShiftGradeViewEmployee = [
  { name: "Employee Code", key: "shift_grade_name" },
  { name: "Employee Name", key: "shift_duration" },
  { name: "Designation", key: "weekoff_days" },
  { name: "Shift Category", key: "factor_weekoff_days" },
  { name: "Shift Group", key: "work_unit" },
];

export const ShiftCategoryViewEmployee = [
  { name: "Employee Code", key: "shift_grade_name" },
  { name: "Employee Name", key: "shift_duration" },
  { name: "Department", key: "shift_duration" },
  { name: "Designation", key: "weekoff_days" },
  { name: "Shift Category", key: "factor_weekoff_days" },
  { name: "Shift Group", key: "work_unit" },
];

export const ShiftCategoryHeader = [
  { name: "Shift Grade Name", key: "name" },
  { name: "Shift Duration", key: "shift_duration" },
  { name: "Working Hours", key: "working_hours_based" },
  { name: "Break Duration (Miniutes)", key: "is_paid_week_off" },
  { name: "No of Employees", key: "is_payment_based_work_unit" },
  { name: "No of Shifts", key: "employee_count" },
  { name: "No of Shifts", key: "employee_count" },
  { name: "Member Action" },
  { name: "Actions" },
];

export const ShiftGroupHeader = [
  { name: "ShiftCategory", key: "shift_category_name" },
  { name: "Name", key: "name" },
  { name: "Department", key: "departments" },
  { name: "Employee Count", key: "group_user_count" },
  { name: "Actions", key: "actions" },
];

export const AdminShiftCategoryHeader = [
  { name: "Shift Category Name", key: "shift_category_name" },
  { name: "Rotaion Period", key: "shift_cycle" },
  { name: "No of Repetation", key: "no_of_cycle" },
  { name: "Start From", key: "start_date" },
  { name: "Repeat Untill", key: "end_date" },
  { name: "Actions", key: "actions" },
];

export const AddShiftCategoryHeader = [
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Start Early",
    key: "min_start_time",
  },
  {
    name: "Start Time",
    key: "start_time",
  },
  {
    name: "Late Start",
    key: "min_end_time",
  },
  {
    name: "Break",
    key: "break_time",
  },
  {
    name: "Early End",
    key: "min_end_time",
  },
  {
    name: "End Time",
    key: "end_time",
  },
  {
    name: "End Late",
    key: "max_end_time",
  },
  {
    name: "Color",
    key: "",
  },
];

export const workUnitTypeList = [{ label: "Default" }, { label: "Fixed" }];

export const shiftDetailsHeader = [
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Min Start Time",
    key: "min_start_time",
  },
  {
    name: "Start Time",
    key: "start_time",
  },
  {
    name: "Max Start Time",
    key: "min_end_time",
  },
  {
    name: "Min End Time",
    key: "break_time",
  },
  {
    name: "End Time",
    key: "min_end_time",
  },
  {
    name: "Max End Time",
    key: "end_time",
  },
];

export const shiftScreenHeader = [
  {
    name: "Shift Name",
    key: "shift_name",
  },
  {
    name: "Shift Start Time",
    key: "shift_start_time",
  },
  {
    name: "Shift Duration",
    key: "shift_duration",
  },
  {
    name: "Checkin/out Policy",
    key: "",
  },
  {
    name: "OverTime Shift Hours Policy",
    key: "",
  },
  {
    name: "Maximum permissionable lateness before being marked as absent",
    key: "",
  },
  {
    name: "Actions",
    key: "",
  },
];

export const ShiftGroupUDHeader = [
  {
    name: "",
    key: "arrow_icon",
  },
  {
    name: "Shift Group Name",
    key: "name",
  },
  {
    name: "Shift Type",
    key: "shift_type",
  },
  {
    name: "Rotation Based On",
    key: "rotation_based_on",
  },
  {
    name: "Primary Shift Grade",
    key: "primary_shift_grade_name",
  },
  {
    name: "No of Shifts",
    key: "no_of_shifts",
  },
  {
    name: "Enable Auto Shift Assign",
    key: "auto_shift_assign",
  },
  {
    name: "Actions",
    key: "",
  },
];

export const rotationBasedOn = [
  {
    label: "Weekdays",
  },
  {
    label: "Shift",
  },
];

export const weekdays = [
  { label: "Monday" },
  { label: "Tuesday" },
  { label: "Wednesday" },
  { label: "Thursday" },
  { label: "Friday" },
  { label: "Saturday" },
  { label: "Sunday" },
];

export const Types = [
  { label: "Continuous" },
  { label: "Non Continuous" },
  { label: "Overlapped" },
];

export const dayType = [{ label: "Full day" }, { label: "Half day" }];

export const daysDetails = [
  { label: "1" },
  { label: "2" },
  { label: "3" },
  { label: "4" },
  { label: "5" },
  { label: "6" },
  { label: "7" },
  { label: "8" },
  { label: "9" },
  { label: "10" },
  { label: "11" },
  { label: "12" },
  { label: "13" },
  { label: "14" },
  { label: "15" },
  { label: "16" },
  { label: "17" },
  { label: "18" },
  { label: "19" },
  { label: "20" },
  { label: "21" },
  { label: "22" },
  { label: "23" },
  { label: "24" },
  { label: "25" },
  { label: "26" },
  { label: "27" },
  { label: "28" },
];

export const userShiftGradeHeader = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Employee Id",
    key: "employee_id",
    type: "string",
    icon: <Badge fontSize="small" />,
  },

  {
    name: "Department",
    key: "department",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Designation",
    key: "designation",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },
  {
    name: "Shift Grade",
    key: "shift_grade_name",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },

  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Effective To",
    key: "effective_to",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Actions",
    key: "",
  },
];
export const userShiftGroupHeader = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Employee Id",
    key: "employee_id",
    type: "string",
    icon: <Badge fontSize="small" />,
  },

  {
    name: "Department",
    key: "department",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Designation",
    key: "designation",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },
  {
    name: "Shift Category",
    key: "shift_category_name",
    type: "autocomplete",
    icon: <Category fontSize="small" />,
  },
  {
    name: "Shift Group",
    key: "shift_group_name",
    type: "autocomplete",
    icon: <Group fontSize="small" />,
  },
  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Effective To",
    key: "effective_to",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Actions",
    key: "",
  },
];
export const userShiftCategoryHeader = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Employee id",
    key: "employee_id",
    type: "string",
    icon: <Badge fontSize="small" />,
  },

  {
    name: "Department",
    key: "department",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Designation",
    key: "designation",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },
  {
    name: "Shift Category",
    key: "shift_category_name",
    type: "autocomplete",
    icon: <Category fontSize="small" />,
  },
  {
    name: "Effective From",
    key: "effective_from",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Effective To",
    key: "effective_to",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "effective_from",
      toField: "effective_to",
    },
  },
  {
    name: "Actions",
    key: "",
  },
];

//Company
export const checkInPolicy = [
  {
    label: "First In",
  },
  {
    label: "Last In",
  },
];

export const checkOutPolicy = [
  {
    label: "First Out",
  },
  {
    label: "Last Out",
  },
];

export const punchHeader = [
  {
    name: "Device Name",
    key: "device_name",
  },
  {
    name: "Location",
    key: "location",
  },
  {
    name: "Mode",
    key: "Mode",
  },
  {
    name: "Action",
    key: "action",
  },
];
export const modeDetails = [
  {
    label: "BI-DIRECTIONAL",
  },
  {
    label: "IN",
  },
  {
    label: "OUT",
  },
];

export const userRoleSearchKey = ["role_name", "products"];

export const userGroupSearchKey = [
  "name",
  "company_name",
  "role_name",
  "item?.assignments",
];

export const shiftHeader = [
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Duration",
    key: "duration",
    type: "time",
    icon: <Timer fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Start Time",
    key: "start_time",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: true,
  },
  {
    name: "End Time",
    key: "end_time",
    type: "time",
    icon: <Schedule fontSize="small" />,
    showBetweenOperator: true,
  },
  {
    name: "Break Duration",
    key: "break_duration",
    type: "number",
    icon: <Schedule fontSize="small" />,
  },
];

export const ShiftGradeHeader = [
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Shift Hours",
    key: "shift_hours",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
];

export const ShiftAssignmentHeader = [
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Type",
    key: "shift_type",
    type: "autocomplete",
    icon: <AutoAwesome fontSize="small" />,
  },
  {
    name: "Rotation Based On",
    key: "rotation_based_on",
    type: "autocomplete",
    icon: <Autorenew fontSize="small" />,
  },
  {
    name: "No of shifts",
    key: "number_of_shifts",
    type: "number",
    icon: <FilterTiltShift fontSize="small" />,
  },
  {
    name: "Auto Shift Assign",
    key: "auto_shift_assign",
    type: "boolean",
    labels: {
      true: "Yes",
      false: "No",
      all: "All",
    },
    icon: <Assignment fontSize="small" />,
  },
];

export const shiftGradeHeader = [
  {
    name: "Name",
    key: "name",
  },
  {
    name: "Duration",
    key: "duration",
  },
  {
    name: "Working Hours",
    key: "start_time",
  },
  {
    name: "Break Allowed",
    key: "end_time",
  },
  {
    name: "Break Duration(mins)",
    key: "end_time",
  },
];

export const AssignSftHeader = [
  {
    name: "",
    key: "Action",
  },
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "No of Current Employees",
    key: "user_count",
    type: "number",
    icon: <PersonAddAlt fontSize="small" />,
  },
  {
    name: "No of Moved Employees",
    key: "moved_users_count",
    type: "number",
    icon: <PersonAddAlt fontSize="small" />,
  },
];

export const AssignShiftGradeHeader = [
  {
    name: "",
    key: "Action",
  },
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "No of Current Employees",
    key: "user_count",
    type: "number",
    icon: <PersonAddAlt fontSize="small" />,
  },
  {
    name: "No of Moved Employees",
    key: "moved_users_count",
    type: "number",
    icon: <PersonAddAlt fontSize="small" />,
  },
  {
    name: "Current Shift Rota",
    key: "shift_rota_name",
    type: "number",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: `Shift on ${moment().format("DD MMM, YYYY")}`,
    key: "current_shift",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
];

export const IndividualUserShiftGradeDetails = [
  {
    name: "Employee ID",
    key: "employee_id",
  },
  {
    name: "Employee Name",
    key: "employee_name",
  },
  {
    name: "Department",
    key: "department",
  },
  {
    name: "Designation",
    key: "designation",
  },
  {
    name: "Effective From",
    key: "effective_from",
  },
  {
    name: "Effective To",
    key: "effective_to",
  },
  {
    name: "Action",
    key: "Action",
  },
];

export const AssignmentName = [
  {
    label: "Shift Grade",
  },
  {
    label: "Shift Group",
  },
  {
    label: "Shift Category",
  },
];

export const shiftCategoryHeader = [
  { name: "Name", key: "name" },
  { name: "Payment Calculation based On", key: "payment_based_on" },
  {
    name: "Earnings",
    children: [
      { name: "Overtime", key: "ot_allowed" },
      { name: "Weekoff", key: "is_paid_week_off" },
      { name: "Holiday", key: "is_paid_holiday" },
      { name: "Absence", key: "is_absence_paid" },
    ],
  },
  {
    name: "Deductions",
    children: [
      { name: "Shift Penalty", key: "shift_penalty_deduction" },
      { name: "Break Penalty", key: "break_penalty_deduction" },
      { name: "Absence Penalty", key: "deduct_salary_for_absence" },
    ],
  },
];

export const SftCategoryHeaders = [
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Payment Calculation based On",
    key: "payment_based_on",
    type: "autocomplete",
    icon: <Payments fontSize="small" />,
  },

  {
    name: "Overtime",
    key: "ot_allowed",
    labels: {
      true: "Enabled",
      false: "Disabled",
    },
    type: "boolean",
    icon: <MoreTime fontSize="small" />,
  },
  {
    name: "Weekoff",
    key: "is_paid_week_off",
    labels: {
      true: "Enabled",
      false: "Disabled",
    },
    type: "boolean",
    icon: <AccessibilityNew fontSize="small" />,
  },
  {
    name: "Holiday",
    key: "is_paid_holiday",
    labels: {
      true: "Enabled",
      false: "Disabled",
    },
    type: "boolean",
    icon: <HolidayVillage fontSize="small" />,
  },
  {
    name: "Absence",
    key: "is_absence_paid",
    labels: {
      true: "Enabled",
      false: "Disabled",
    },
    type: "boolean",
    icon: <PersonOff fontSize="small" />,
  },
  {
    name: "Shift Penalty",
    key: "shift_penalty_deduction",
    labels: {
      true: "Enabled",
      false: "Disabled",
    },
    type: "boolean",
    icon: <AttachMoney fontSize="small" />,
  },
  {
    name: "Break Penalty",
    key: "break_penalty_deduction",
    labels: {
      true: "Enabled",
      false: "Disabled",
    },
    type: "boolean",
    icon: <FreeBreakfast fontSize="small" />,
  },
  {
    name: "Absence Penalty",
    key: "deduct_salary_for_absence",
    labels: {
      true: "Enabled",
      false: "Disabled",
    },
    type: "boolean",
    icon: <PersonOff fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

export const employeeViewSftGradeKeys = [
  "employee_id",
  "employee_name",
  "department",
  "designation",
  "shift_category_name",
  "shift_group_name",
  "effective_from",
  "effective_to",
];

export const employeeViewSftGroupKeys = [
  "employee_id",
  "employee_name",
  "department",
  "designation",
  "shift_category_name",
  "shift_group_name",
  "effective_from",
  "effective_to",
];

export const employeeViewCategoryKeys = [
  "employee_id",
  "employee_name",
  "department",
  "designation",
  "shift_category_name",
  "shift_category_id",
];

export const AssignmentConfigMap = {
  "Shift Grade": {
    title: "Move Shift Grade",
    content:
      "Moving this shift grade will affect historical records, including attendance, overtime, and penalties. Do you want to proceed with these changes?",
  },

  "Shift Group": {
    title: "Move Shift Group",
    content:
      "Moving this shift group will affect historical records, including attendance, overtime, and penalties. Do you want to proceed with these changes?",
  },

  "Shift Category": {
    title: "Move Shift Category",
    content:
      "Moving this shift category will affect historical records, including attendance, overtime, and penalties. Do you want to proceed with these changes?",
  },
};
